/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put, takeEvery } from "redux-saga/effects";
import { newRequest } from "../../../../api/token";
// import { customNotify } from "../../../../components/UI/ToastNotify";
import {
  POST_ACTIVITY_SEARCH,
  GET_ACTIVITIES_LIST,
  GET_ACTIVITY_EXTRA_DETAILS,
  GET_ACTIVITY_AGE_BAND,
  GET_ACTIVITY_CATEGORIES,
  GET_ACTIVITY_ALL_DETAILS,
  GET_ACTIVITY_PRODUCT_INFO,
  ACTIVITY_PRE_BOOK,
  ACTIVITY_CHECKOUT,
  PASSPORT_DETAILS_BY_BOOKINGID,
} from "../../../actionTypes/Dashboard/activityActionTypes";
import {
  postActiviySearchAction,
  getActivitiesListAction,
  getActivityExtraDetailsAction,
  getActivityAgeBandAction,
  getActivityCategoriesAction,
  getActivityAllDetailsAction,
  getActivityProductInfoAction,
  activityPreBookAction,
  activityCheckoutAction,
  passportDetailsByBookingIdAction,
} from "../../../actions/Dashboard/activityActions";
import {
  GET_ACTIVITY_AGEBAND_WRAPPER,
  GET_ACTIVITY_ALLDETAILS_WRAPPER,
  GET_ACTIVITY_CATEGORIES_WRAPPER,
  GET_ACTIVITY_CHECKOUT_WRAPPER,
  GET_ACTIVITY_EXTRADETAILS_WRAPPER,
  GET_ACTIVITY_LIST_WRAPPER,
  GET_ACTIVITY_PREBOOK_WRAPPER,
  GET_ACTIVITY_PRODUCTINFO_WRAPPER,
  GET_ACTIVITY_SEARCH_WRAPPER,
} from "../../../gqlQueries/Dashboard/grnQuery";
import { getToken, getWrapperToken } from "../../../../utils/helpers/auth";
import { PASSPORT_DETAILS_BY_BOOKINGID_QUERY } from "../../../gqlQueries/Dashboard/bookingsQuery";
import { getNotificationMessage } from "../../../actions/localStorageActions";

//ACTIVIY SEARCH START
function* postActivitySearch(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    search: JSON.stringify(action?.payload),
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ACTIVITY_SEARCH_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.postActivitySearch?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.postActivitySearch?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.postActivitySearch?.responseData
    ) {
      yield put(
        postActiviySearchAction.FULLFILLED({
          data: data?.data?.postActivitySearch?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
        isOpen: true,
        mainHeader: "Something went wrong",
        subHeader: "",
        message: "Search Key is not available",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(postActiviySearchAction.REJECTED());
    }
  } catch (error: any) {
    const message = {
      isOpen: true,
      mainHeader:
        "System taking too long to load the results. Check your network and try again",
      subHeader: "",
      message: "",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(postActiviySearchAction.REJECTED());
  }
}
//ACTIVITY SEARCH END

function* getActivitiesList(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    ts: action?.payload.searchKey,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACTIVITY_LIST_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.activityList?.successTypeCode?.toLowerCase() == "success" &&
      data?.data?.activityList?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.activityList?.responseData
    ) {
      yield put(
        getActivitiesListAction.FULLFILLED({
          data: data?.data?.activityList?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
        isOpen: true,
        mainHeader: "Something went wrong",
        subHeader: "",
        message: "Activities List are not available",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(getActivitiesListAction.REJECTED());
      action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
    }
  } catch (error: any) {
    const message = {
      isOpen: true,
      mainHeader:
        "System taking too long to load the results. Check your network and try again",
      subHeader: "",
      message: "",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(getActivitiesListAction.REJECTED());
    action?.payload?.setNoDataFlag && action?.payload?.setNoDataFlag(true);
  }
}

function* getActivityExtraDetails(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    productIds: action?.payload?.ProductIds,
    ts: action?.payload?.ts,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACTIVITY_EXTRADETAILS_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.activityExtraDetails?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.activityExtraDetails?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.activityExtraDetails?.responseData
    ) {
      yield put(
        getActivityExtraDetailsAction.FULLFILLED({
          data: data?.data?.activityExtraDetails?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
        isOpen: true,
        mainHeader: "No Records Found",
        subHeader: "",
        message: "Activity Extra Details are not available",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(getActivityExtraDetailsAction.REJECTED());
    }
  } catch (error: any) {
    const message = {
      isOpen: true,
      mainHeader: "Something went wrong",
      subHeader: "",
      message: "Unable to fetch Activity Extra Details.",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(getActivityExtraDetailsAction.REJECTED());
  }
}

function* getActivityAgeBands(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    productCode: action?.payload?.productCode,
    ts: action?.payload?.ts,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACTIVITY_AGEBAND_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.activityAgeBand?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.activityAgeBand?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.activityAgeBand?.responseData
    ) {
      yield put(
        getActivityAgeBandAction.FULLFILLED({
          data: data?.data?.activityAgeBand?.responseData,
          status: 200,
        })
      );
      if (action?.payload?.getSuccess) {
        action?.payload?.getSuccess(
          data?.data?.activityAgeBand?.responseData
        );
      }
    } else {
      const message = {
        isOpen: true,
        mainHeader: "No Activity Age Bands records found",
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      yield put(getActivityAgeBandAction.REJECTED());
      if (action?.payload?.getError) {
        action?.payload?.getError(message);
      }
    }
  } catch (error: any) {
    const message = {
      isOpen: true,
      mainHeader: "Something went wrong",
      subHeader: "",
      message: "Unable to fetch Activity Age Bands.",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(getActivityAgeBandAction.REJECTED());
    if (action?.payload?.getError) {
      action?.payload?.getError(message);
    }
  }
}

function* getActivityCategories(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    ts: action?.payload,
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GET_ACTIVITY_CATEGORIES_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.activityCategories?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.activityCategories?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.activityCategories?.responseData
    ) {
      yield put(
        getActivityCategoriesAction.FULLFILLED({
          data: data?.data?.activityCategories?.responseData,
          status: 200,
        })
      );
    } else {
      yield put(getActivityCategoriesAction.REJECTED());
    }
  } catch (error: any) {
    yield put(getActivityCategoriesAction.REJECTED());
  }
}

function* getActivityAllDetails(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    search: JSON.stringify({
      ProductCode: action?.payload?.request?.ProductCode,
      searchId: action?.payload?.request?.searchId,
      _ts: action?.payload?.request?._ts,
      groupCode: action?.payload?.request?.groupCode,
    }),
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ACTIVITY_ALLDETAILS_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.postActivityAllDetails?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityAllDetails?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityAllDetails?.responseData
    ) {
      yield put(
        getActivityAllDetailsAction.FULLFILLED({
          data: data?.data?.postActivityAllDetails?.responseData,
          status: 200,
        })
      );
    } else {
      action?.payload?.setNoActFoundFlag((prev: any) => ({
        ...prev,
        activity_details: true,
      }));
      yield put(getActivityAllDetailsAction.REJECTED());
    }
  } catch (error: any) {
    action?.payload?.setNoActFoundFlag((prev: any) => ({
      ...prev,
      activity_details: true,
    }));
    yield put(getActivityAllDetailsAction.REJECTED());
  }
}

function* getActivityProductInfo(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    search: JSON.stringify({
      productCode: action?.payload?.request?.ProductCode,
      searchId: action?.payload?.request?.searchId,
      _ts: action?.payload?.request?._ts,
      groupCode: action?.payload?.request?.groupCode,
    }),
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ACTIVITY_PRODUCTINFO_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.postActivityProductInfo?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityProductInfo?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityProductInfo?.responseData
    ) {
      yield put(
        getActivityProductInfoAction.FULLFILLED({
          data: data?.data?.postActivityProductInfo?.responseData,
          status: 200,
        })
      );
      if (action?.payload?.setCalculateFlag) {
        action?.payload?.setCalculateFlag(true);
      }
      if (action?.payload?.getSuccess) {
        action?.payload?.getSuccess(data?.data?.postActivityProductInfo?.responseData);
      }
    } else {
      action?.payload?.setNoActFoundFlag((prev: any) => ({
        ...prev,
        product_info: true,
      }));
      if (action?.payload?.getError) {
        action?.payload?.getError("error");
      }
      if (action?.payload?.setProductInfoAvailabeFlag) {
        action?.payload?.setProductInfoAvailabeFlag(true);
      }

      yield put(getActivityProductInfoAction.REJECTED());
    }
  } catch (error: any) {
    action?.payload?.setNoActFoundFlag((prev: any) => ({
      ...prev,
      product_info: true,
    }));
    if (action?.payload?.getError) {
      action?.payload?.getError(error);
    }
    if (action?.payload?.setProductInfoAvailabeFlag) {
      action?.payload?.setProductInfoAvailabeFlag(true);
    }
    yield put(getActivityProductInfoAction.REJECTED());
  }
}

function* activityPreBook(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    search: JSON.stringify({
      ProductId: action?.payload,
      ts: action?.payload?.ts,
      sid: action?.payload?.sid,
      type: action?.payload?.type,
      groupCode: action?.payload?.groupCode,
      bookingKey: action?.payload?.bookingKey,
      currency: action?.payload?.currency,
    }),
  };

  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ACTIVITY_PREBOOK_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      data?.data?.postActivityPrebook?.successTypeCode?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityPrebook?.responseData?.status?.toLowerCase() ==
      "success" &&
      data?.data?.postActivityPrebook?.responseData
    ) {
      yield put(
        activityPreBookAction.FULLFILLED({
          data: data?.data?.postActivityPrebook?.responseData,
          status: 200,
        })
      );
    } else {
      const message = {
        isOpen: true,
        mainHeader: "pre-book failed",
        subHeader: "",
        message: "",
        subReq: false,
      };
      yield put(getNotificationMessage(message));
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(activityPreBookAction.REJECTED());
    }
  } catch (error: any) {
    const message = {
      isOpen: true,
      mainHeader:
        "System taking too long to load the results. Check your network and try again",
      subHeader: "",
      message: "",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    yield put(activityPreBookAction.REJECTED());
  }
}

function* activityCheckout(action: any): any {
  const customHeaders = {
    headers: {
      Authorization: getToken() && `Bearer ${getToken()}`,
      "Wrapper-Token": getWrapperToken() && `Bearer ${getWrapperToken()}`,
    },
    input: JSON.stringify(action?.payload?.apiPayload),
    sid: action?.payload?.sid,
    hubSearchId: action?.payload?.hubSearchId || "",
  };

  try {
    const apiData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: GET_ACTIVITY_CHECKOUT_WRAPPER,
      clientType: "BE",
      data: customHeaders,
    });

    if (
      apiData?.data?.postActivityCheckout?.successTypeCode?.toLowerCase() ==
      "success" &&
      apiData?.data?.postActivityCheckout?.responseData?.status?.toLowerCase() ==
      "success"
    ) {
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      action?.payload?.getCheckoutDetails?.(
        apiData?.data?.postActivityCheckout?.responseData?.data?.status?.toLowerCase()
      );
      yield put(
        activityCheckoutAction.FULLFILLED({
          data: apiData?.data?.postActivityCheckout?.responseData,
          status: 200,
        })
      );
    } else {
      if (action?.payload?.callingFrom == "online") {
        setTimeout(() => {
          window.location.href = "/";
        }, 5000);
      }
      action?.payload?.getCheckoutDetails?.("pending");
      action?.payload?.setLoader && action?.payload?.setLoader(false);
      yield put(activityCheckoutAction.REJECTED());
    }
  } catch (error: any) {
    if (action?.payload?.callingFrom == "online") {
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
    action?.payload?.getCheckoutDetails?.("pending");
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    yield put(activityCheckoutAction.REJECTED());
  }
}

function* passportDetailsByBookingIdCall(action: any): any {
  const token = getToken() ? getToken() : "";
  const customHeaders = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    booking_reference_id: action?.payload?.booking_reference_id,
  };
  try {
    const BookingDataByBid = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: PASSPORT_DETAILS_BY_BOOKINGID_QUERY,
      data: customHeaders,
      clientType: "MO",
    });
    action?.payload?.setLoader && action?.payload?.setLoader(false);

    if (BookingDataByBid?.data?.passportDetailsByBookingId?.responseData) {
      yield put(
        passportDetailsByBookingIdAction.FULLFILLED(
          BookingDataByBid?.data?.passportDetailsByBookingId
        )
      );
    } else {
      yield put(passportDetailsByBookingIdAction.FULLFILLED({}));
    }
  } catch (error) {
    action?.payload?.setLoader && action?.payload?.setLoader(false);
    yield put(passportDetailsByBookingIdAction.REJECTED(error));
  }
}

export function* watcherActivity() {
  yield takeLatest(POST_ACTIVITY_SEARCH.STARTED, postActivitySearch);
  yield takeLatest(GET_ACTIVITIES_LIST.STARTED, getActivitiesList);
  yield takeEvery(GET_ACTIVITY_EXTRA_DETAILS.STARTED, getActivityExtraDetails);
  yield takeLatest(GET_ACTIVITY_AGE_BAND.STARTED, getActivityAgeBands);
  yield takeLatest(GET_ACTIVITY_CATEGORIES.STARTED, getActivityCategories);
  yield takeLatest(GET_ACTIVITY_ALL_DETAILS.STARTED, getActivityAllDetails);
  yield takeLatest(GET_ACTIVITY_PRODUCT_INFO.STARTED, getActivityProductInfo);
  yield takeLatest(ACTIVITY_PRE_BOOK.STARTED, activityPreBook);
  yield takeLatest(ACTIVITY_CHECKOUT.STARTED, activityCheckout);
  yield takeLatest(
    PASSPORT_DETAILS_BY_BOOKINGID.STARTED,
    passportDetailsByBookingIdCall
  );
}

export const sagas = [watcherActivity];
